export const uwFilters = {
  data() {
    return {
      showPolicyHelpList: false,
      filtersPolicyLabel: {
        policyNo: 'Policy No.'
      },
      filtersPolicy: {
        policyNo: undefined
      },
      filtersOpenCoverMasterPolicyLabel: {
        policyNo: 'Policy No.',
        insdName1: 'Insured Name'
      },
      filtersOpenCoverMasterPolicy: {
        policyNo: undefined,
        insdName1: undefined
      },
      polItems: [],
      totalItemsPol: 0,
      polHeaders: [
        { text: 'Policy No.', align: 'left', value: 'polNo' },
        { text: 'Renewal Count', align: 'left', value: 'renCnt' },
        { text: 'Endorsement Count', align: 'left', value: 'endtCnt' },
        { text: 'Insured Name', align: 'left', value: 'insdName1' },
        { text: 'Commencement Date', align: 'left', value: 'comDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Action', align: 'center', sortable: false, value: '' }
      ],
      paginationPolicy: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      paginationPolicyRenewal: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      }
    }
  },
  watch: {
    'paginationPolicy': function (value) {
      this.fetchPolicyData()
    }
  }
}
